// Initialize EasyMDE on any markdown editor textareas
import EasyMDE from "easymde";

function initializeMarkdownEditors() {
  const textareas = document.querySelectorAll(
    '[data-markdown-editor-target="editor"]',
  );

  textareas.forEach((textarea) => {
    // Skip if already initialized
    if (textarea.easymde) {
      return;
    }

    // Fetch image URLs if a page ID is available
    const pageId = textarea.dataset.pageId;
    if (pageId) {
      fetch(`/extracted_pages/${pageId}.json`)
        .then((r) => r.json())
        .then((data) => {
          textarea._imageUrls = data.image_urls || [];
          // Replace <!-- image --> placeholders in the editor content
          if (textarea._imageUrls.length > 0 && editor) {
            let imageIndex = 0;
            const currentContent = editor.value();
            const updatedContent = currentContent.replace(
              /<!--\s*image\s*-->/gi,
              () => {
                const url = textarea._imageUrls[imageIndex];
                imageIndex++;
                return url
                  ? `![image ${imageIndex}](${url})`
                  : `<!-- image ${imageIndex} (not available) -->`;
              },
            );
            if (updatedContent !== currentContent) {
              editor.value(updatedContent);
            }
          }
        })
        .catch(() => {
          textarea._imageUrls = [];
        });
    }

    let editor;
    editor = new EasyMDE({
      element: textarea,
      toolbar: [
        "bold",
        "italic",
        "heading",
        "|",
        "quote",
        "unordered-list",
        "ordered-list",
        "|",
        "link",
        "image",
        "|",
        "preview",
        "side-by-side",
        "fullscreen",
        "|",
        "guide",
      ],
      minHeight: "400px",
      autoDownloadFontAwesome: false,
      spellChecker: false,
      status: ["lines", "words", "cursor"],
      placeholder: "Enter markdown content here...",
      previewRender: (plainText) => {
        let imageIndex = 0;
        const processed = plainText.replace(/<!--\s*image\s*-->/gi, () => {
          const urls = textarea._imageUrls || [];
          const url = urls[imageIndex];
          imageIndex++;
          return url
            ? `![image ${imageIndex}](${url})`
            : `<!-- image ${imageIndex} (not available) -->`;
        });
        return editor.markdown(processed);
      },
    });

    // Make image links open in new tab when preview panel is shown
    const origTogglePreview = editor.togglePreview.bind(editor);
    editor.togglePreview = () => {
      origTogglePreview();
      setTimeout(() => {
        const preview = editor.codemirror
          .getWrapperElement()
          .parentNode.querySelector(".editor-preview, .editor-preview-side");
        if (preview) {
          preview.querySelectorAll('a[href*="/image/"]').forEach((a) => {
            a.setAttribute("target", "_blank");
          });
        }
      }, 50);
    };

    // Store reference to prevent re-initialization
    textarea.easymde = editor;
  });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  initializeMarkdownEditors();
});

// Initialize after Turbo loads new content
document.addEventListener("turbo:load", () => {
  initializeMarkdownEditors();
});

// Initialize after Turbo Stream renders
document.addEventListener("turbo:before-stream-render", () => {
  setTimeout(initializeMarkdownEditors, 100);
});

// Also watch for any DOM mutations (fallback)
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length > 0) {
      const hasEditorTarget = Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType === 1) {
          // Element node
          return (
            node.matches('[data-markdown-editor-target="editor"]') ||
            node.querySelector('[data-markdown-editor-target="editor"]')
          );
        }
        return false;
      });

      if (hasEditorTarget) {
        setTimeout(initializeMarkdownEditors, 50);
        break;
      }
    }
  }
});

// Start observing the document for changes
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
